import { createReducer, on } from '@ngrx/store';
import { ReportDomain } from '@mode/shared/contract-common';
import * as ReportParameterOptionsActions from './report-parameter-options.actions';

export const reportParameterOptionsFeatureKey = 'reportParameterOptions';

export interface ReportParameterOptionsFeatureState {
  options: ReportDomain.ReportRunFormFieldOptions[];
  optionsLoading: boolean;
  isComplete: boolean;
  error: Error | null;
}

export const initialReportParameterOptionsFeatureState: ReportParameterOptionsFeatureState = {
  optionsLoading: false,
  options: [],
  isComplete: false,
  error: null,
};

export const reducer = createReducer(
  initialReportParameterOptionsFeatureState,

  on(ReportParameterOptionsActions.loadReportParameterOptions, (state) => ({
    ...state,
    optionsLoading: true,
    isComplete: false,
    error: null,
  })),
  on(ReportParameterOptionsActions.loadReportParameterOptionsSuccess, (state, action) => {
    return { ...state, options: action.options, optionsLoading: false, error: null, isComplete: true };
  }),
  on(ReportParameterOptionsActions.loadReportParameterOptionsFailure, (state, action) => {
    return { ...state, error: action.error, optionsLoading: false, isComplete: true, options: [] };
  })
);
